import { Helmet } from "react-helmet-async";
import { IoIosArrowForward } from "react-icons/io";

const menuItems = [
    { id: 1, name: "Devices", href: "/Devices", icon: "Vector.svg" },
    { id: 2, name: "Maintenance Schedules", href: "/maintenance-schedules", icon: "Group.svg" },
    { id: 3, name: "Diagnostics History", href: "/diagnostics-history", icon: "Vector (1).svg" },
    { id: 4, name: "Firmware Update", href: "/Firmware-Update", icon: "Group (1).svg" },
    { id: 5, name: "Alerts", href: "/alerts", icon: "Vector (2).svg" },

];

const HomePage = () => {
    return (
        <>   
        <Helmet>
            <title>Serco - Home</title>
            <meta name="description" content="Serco is a smart home management system." />
        </Helmet>
             <section className=" fixed h-screen w-full bg-custom">
            <header className=" flex items-center px-6 justify-start bg-DarkBlue border-b-4 border-DarkRed w-full h-[10%]">
                <figure className="">
                    <img
                        src="/Icons/brand-logo.svg"
                        alt="brand-logo"
                        title="Serco-Logo"
                        className=" object-contain w-auto"
                    />
                </figure>
            </header>
            <div className=" h-full w-full flex justify-center items-start pt-44">
                <div className="grid grid-cols-3 gap-6 p-3">
                    {menuItems.map((item, index) => (


                        <a title={item.name} key={item.id}

                            href={item.href}
                            className="flex items-center text-white  bg-DarkBlue rounded-md px-2  overflow-hidden  h-20 hover:bg-DarkGray transition-colors"
                        >

                            <figure className=" mx-1 p-1 w-14">
                                <img src={`/SidebaarIcons/${item.icon}`} className=" object-contain" alt={item.name} title={item.name} />
                            </figure>




                            <span className=" border-r  h-full opacity-50 border-white   "></span>
                            <div className=" flex w-full justify-between items-center mx-2">

                                <span className=" text-base ">{item.name}  </span>
                                <IoIosArrowForward size={20} />
                            </div>




                        </a>

                    ))}



                </div>
            </div>

        </section>
        </>

    );
}

export default HomePage;